export default __webpack_public_path__ + "static/media/qr.1e50e214.png";